export const fastTrackPath = 'simple-onboarding-checklist';
export const rescheduleAppointmentPath = 'reschedule-appointment';
